import { render, staticRenderFns } from "./group-savings.vue?vue&type=template&id=3dc597ba"
import script from "./group-savings.vue?vue&type=script&lang=js"
export * from "./group-savings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports